export default "__VITE_ASSET__BYWhUSff__"